export const NAV = {
    langToggle: "nav-lang-toggle",
    logo: "nav-logo",
    home: "nav-home-link",
    studio: "nav-studio-link",
    pricing: "nav-pricing-link",
    login: "nav-login-btn",
    signup: "nav-signup-btn",
    logout: "nav-logout-btn",
    userBadge: "nav-user-badge",
};

export const LANDING = {
    heroCTA: "landing-hero-cta",
    heroLogin: "landing-hero-login",
    seePricing: "landing-see-pricing",
    modulesGrid: "landing-modules-grid",
    pricingSection: "pricing-plans-section",
    starterPlan: "pricing-starter-plan",
    creatorPlan: "pricing-creator-plan",
    factoryPlan: "pricing-factory-plan",
    proPlan: "pricing-pro-plan",
    starterCTA: "pricing-starter-cta",
    creatorCTA: "pricing-creator-cta",
    factoryCTA: "pricing-factory-cta",
    proCTA: "pricing-pro-cta",
};

export const AUTH = {
    tabLogin: "auth-tab-login",
    tabRegister: "auth-tab-register",
    email: "auth-email-input",
    password: "auth-password-input",
    name: "auth-name-input",
    submit: "auth-submit-btn",
};

export const STUDIO = {
    container: "studio-container",
    tabsList: "studio-tabs-list",
    quizTab: "studio-tab-quiz",
    episodeTab: "studio-tab-episode",
    characterTab: "studio-tab-character",
    calendarTab: "studio-tab-calendar",
    viralTab: "studio-tab-viral",
    moneyTab: "studio-tab-money",
    editTab: "studio-tab-editing",
    voiceTab: "studio-tab-voice",
    libraryTab: "studio-tab-library",
};

export const QUIZ = {
    container: "concept-quiz-container",
    daily: "quiz-daily-slider",
    onCamera: "quiz-on-camera",
    style: "quiz-style-select",
    audience: "quiz-audience-select",
    generateBtn: "quiz-generate-btn",
    result: "quiz-result-panel",
};

export const EPISODE = {
    container: "episode-generator-studio",
    channel: "episode-channel-input",
    character: "episode-character-input",
    idea: "episode-idea-textarea",
    tone: "episode-tone-select",
    generateBtn: "episode-generate-btn",
    result: "episode-result-panel",
};

export const CHARACTER = {
    container: "character-studio-sheet",
    name: "character-name-input",
    species: "character-species-input",
    traits: "character-traits-textarea",
    universe: "character-universe-input",
    generateBtn: "character-generate-btn",
    imageBtn: "character-image-btn",
    result: "character-result-panel",
};

export const CALENDAR30 = {
    container: "production-calendar-grid",
    channel: "calendar-channel-input",
    character: "calendar-character-input",
    theme: "calendar-theme-input",
    generateBtn: "calendar-generate-btn",
    result: "calendar-result-panel",
};

export const VIRAL = {
    container: "viral-lab-analyzer",
    url: "viral-url-input",
    description: "viral-description-textarea",
    analyzeBtn: "viral-analyze-btn",
    result: "viral-result-panel",
};

export const MONEY = {
    container: "monetization-roadmap",
    subscribers: "money-subs-slider",
    niche: "money-niche-input",
    generateBtn: "money-generate-btn",
    result: "money-result-panel",
};
